const firstString = (...values) =>
  values.find((value) => typeof value === 'string' && value.trim() !== '') ?? null;

export const extractApiError = (body) => {
  if (!body) return null;
  if (typeof body === 'string') {
    const detail = firstString(body);
    return detail ? { code: null, detail } : null;
  }

  const error = typeof body.error === 'object' && body.error !== null ? body.error : null;

  const code = firstString(error?.code, body.code);
  const detail = firstString(
    error?.event,
    error?.message,
    typeof body.error === 'string' ? body.error : null,
    body.event,
    body.message,
    body.errorMessage,
    typeof body.data === 'string' ? body.data : null,
    body.data?.message
  );

  return code || detail ? { code, detail } : null;
};

export const formatErrorDetail = (error) =>
  error ? [error.code, error.detail].filter(Boolean).join(' · ') || null : null;

const isInternalMessage = (text) => /^GTP\b/i.test(text.trim());

export const toPaymentError = (error, fallbackMessage) => {
  const detail = error?.detail ?? null;

  if (detail && !isInternalMessage(detail)) {
    return { message: detail, detail: null };
  }

  return { message: fallbackMessage, detail: formatErrorDetail(error) };
};
